import React, { useEffect, useState } from 'react'
import {
	validateAlphaIfPresent,
	validateAlphaNumericIfPresent,
	validateAddressIfPresent,
	validateRequired,
} from '../../CaptureAWB/captureAwbUtils'
import {
	hasError,
	removeError,
	validateEmailIfPresent,
	validateNameRequired,
	validatePhoneNumberIfPresent,
	validatePostalCodeIfPresent,
	validateParticipants,
	validatePhoneCountryCode,
} from '../CaptureHawbValidations'
import './index.scss'
import CountryAutocomplete from '../../CountryAutocomplete'
import { AUTOCOMPLETE_TYPE_COUNTRY } from '../../../constants'
import { useTranslation } from 'react-i18next'
import CommonInput from '../../../common/Resusable/CommonInput'
import CountryCodeDropdown from '../../UserManagement/CountryCodeDropdown'
import { COUNTRY_CODES } from '../../../constants/countryCodes'
import { sort } from '../../../utils/common'
const ParticipantDetails = ({
	isExpanded,
	hawbResponseDetails,
	shipperDetails,
	setShipperDetails,
	consigneeDetails,
	setConsigneeDetails,
	awbResponseDetails,
	initialStateConsigneeDetails,
	initialStateShipperDetails,
	error,
	setError,
}) => {
	//for multilingual
	const { t,i18n } = useTranslation(['labels', 'errors'])
	const isRTL = i18n.language === 'ar' || i18n.dir() === 'rtl';
	const [awbShipperDetails, setAwbShipperDetails] = useState(null)
	const [awbConsigneeDetails, setAwbConsigneeDetails] = useState(null)
	const [existingHawbShipperDetails, setExistingHawbShipperDetails] =
		useState(null)
	const [existingHawbConsigneeDetails, setExistingConsigneerDetails] =
		useState(null)
	const [selectedShipperCountry, setSelectedShipperCountry] = useState(null)
	const [selectedCosigneeCountry, setSelectedCosigneeCountry] = useState(null)
	const [shipperPhoneCountryCode, setShipperPhoneCountryCode] = useState('+971');
    const [shipperPhoneNumber, setShipperPhoneNumber] = useState('');
	const [consigneePhoneCountryCode, setConsigneePhoneCountryCode] = useState('+971');
    const [consigneePhoneNumber, setConsigneePhoneNumber] = useState('');

	const [sortedCountryCodes, setSortedCountryCodes] = useState([]);

	useEffect(() => {
		setSortedCountryCodes(sort(COUNTRY_CODES))
	}, []);

	const bindPhoneNumber = {
		value: shipperPhoneNumber,
		onChange: (e) => {
		const value = e.target.value;
        setShipperPhoneNumber(value);
        setShipperDetails(prev => ({
            ...prev,
            shipperPhone: value,
            phContryCode: shipperPhoneCountryCode
        }));
		}
	};

const triggerPhoneCodeValidation = () => {
    validatePhoneCountryCode(shipperPhoneCountryCode, shipperPhoneNumber, setError);
};

//  const handleCountryCodeChange = (code) => {
//         setShipperPhoneCountryCode(code);
//         setShipperDetails(prev => ({
//             ...prev,
//             phContryCode: code,
//             shipperPhone: shipperPhoneNumber
//         }));
//         triggerPhoneCodeValidation();
//     };

const handleCountryCodeChange = (code) => {
    setShipperDetails(prev => ({
        ...prev,
        phContryCode: code
    }));
    triggerPhoneCodeValidation();
};

 const handlePhoneNumberChange = (e) => {
        const value = e.target.value;
        setShipperPhoneNumber(value);
        setShipperDetails(prev => ({
            ...prev,
            shipperPhone: value,
            phContryCode: shipperPhoneCountryCode
        }));
    };

const handlePhoneBlur = (e) => {
        const value = e.target.value;
        validatePhoneNumberIfPresent(
            value,
            setError,
            'shipperTelephone'
        );
        setShipperDetails(prev => ({
            ...prev,
            shipperPhone: value,
            phContryCode: shipperPhoneCountryCode
        }));
    };

	const bindConsigneePhoneNumber = {
    value: consigneePhoneNumber,
    onChange: (e) => {
        const value = e.target.value;
        setConsigneePhoneNumber(value);
        setConsigneeDetails(prev => ({
            ...prev,
            consigneePhone: value,
            consigneePhContryCode: consigneePhoneCountryCode
        }));
    }
};

const triggerConsigneePhoneCodeValidation = () => {
    validatePhoneCountryCode(consigneePhoneCountryCode, consigneePhoneNumber, setError);
};

const handleConsigneeCountryCodeChange = (code) => {
    setConsigneePhoneCountryCode(code);
    setConsigneeDetails(prev => ({
        ...prev,
        consigneePhContryCode: code,
        consigneePhone: consigneePhoneNumber
    }));
    triggerConsigneePhoneCodeValidation();
};

const handleConsigneePhoneBlur = (e) => {
    const value = e.target.value;
    validatePhoneNumberIfPresent(
        value,
        setError,
        'consigneeTelephone'
    );
    setConsigneeDetails(prev => ({
        ...prev,
        consigneePhone: value,
        consigneePhContryCode: consigneePhoneCountryCode
    }));
};

	useEffect(() => {
		if (awbResponseDetails) {
			setAwbShipperDetails(awbResponseDetails.awbShipperDetails)
			setAwbConsigneeDetails(awbResponseDetails.awbConsigneeDetails)
		}
		if (hawbResponseDetails && hawbResponseDetails.shipperDetails) {
			const fullPhone = hawbResponseDetails.shipperDetails.shipperPhone || '';
			let code = '';
			let phone = '';

			if (fullPhone.includes('-')) {
				[code, phone] = fullPhone.split('-');
			} else {
				phone = fullPhone;
			}

			console.log('fullPhone:', fullPhone);
			console.log('code:', code, 'phone:', phone);

			setShipperDetails({
				...hawbResponseDetails.shipperDetails,
				shipperPhone: phone,
				phContryCode: code ? { code } : { code: '' }, 
			});
			
			setExistingHawbShipperDetails({
				...hawbResponseDetails.shipperDetails,
				shipperPhone: phone,
				phContryCode: code ? { code } : { code: '' },
			});
			// setShipperDetails(hawbResponseDetails.shipperDetails)
			// setExistingHawbShipperDetails(hawbResponseDetails.shipperDetails)
			setSelectedShipperCountry(
				hawbResponseDetails.shipperDetails.shipperCountry
			)
		}
		if (hawbResponseDetails && hawbResponseDetails.consigneeDetails) {

			const fullPhone = hawbResponseDetails.consigneeDetails.consigneePhone || '';
			let code = '';
			let phone = '';

			if (fullPhone.includes('-')) {
				[code, phone] = fullPhone.split('-');
			} else {
				phone = fullPhone;
			}

			setConsigneeDetails({
				...hawbResponseDetails.consigneeDetails,
				consigneePhone: phone,
				phContryCode: code ? { code } : { code: '' },
			});
			
			setExistingConsigneerDetails({
				...hawbResponseDetails.consigneeDetails,
				consigneePhone: phone,
				phContryCode: code ? { code } : { code: '' },
			});

			// setConsigneeDetails(hawbResponseDetails.consigneeDetails)
			// setExistingConsigneerDetails(hawbResponseDetails.consigneeDetails)
			setSelectedCosigneeCountry(
				hawbResponseDetails.consigneeDetails.consigneeCountry
			)
		}
	}, [hawbResponseDetails, awbResponseDetails])

	useEffect(() => {
		setShipperDetails({
			...shipperDetails,
			shipperCountry: selectedShipperCountry,
		})
	}, [selectedShipperCountry])

	useEffect(() => {
		setConsigneeDetails({
			...consigneeDetails,
			consigneeCountry: selectedCosigneeCountry,
		})
	}, [selectedCosigneeCountry])

	const handleChangeShipperDetail = (evnt) => {
		if (evnt.target.checked && awbShipperDetails) {

			console.log('awbShipperDetails:', awbShipperDetails);

			setShipperDetails({
				...shipperDetails,
				shipperName: awbShipperDetails.shipperName,
				shipperAddress1: awbShipperDetails.shipperAddress1,
				shipperCity: awbShipperDetails.shipperCity,
				shipperState: awbShipperDetails.shipperState,
				shipperCountry: awbShipperDetails.shipperCountry,
				shipperPostalCode: awbShipperDetails.shipperPostalCode,
				shipperAccountNumber: awbShipperDetails.shipperAccountNumber,
				shipperPhone: awbShipperDetails.shipperPhone,
				shipperMail: awbShipperDetails.shipperMail,
				phContryCode: awbShipperDetails.phContryCode,
			});

			checkShipperValidations()
		} else if (!evnt.target.checked && existingHawbShipperDetails !== null) {
			setShipperDetails({ ...existingHawbShipperDetails })
			checkShipperValidations()
		} else {
			setShipperDetails({ ...initialStateShipperDetails })
		}
	}
	console.log('shipperDetails:', shipperDetails);

	const checkShipperValidations = () => {
		setError((prevState) => ({ ...prevState, 'shipperName': '' }))
		setError((prevState) => ({ ...prevState, 'shipperAddress': '' }))
		setError((prevState) => ({ ...prevState, 'shipperCity': '' }))
		setError((prevState) => ({ ...prevState, 'shipperCountry': '' }))
		validateParticipants(awbShipperDetails, awbConsigneeDetails, setError)
	}

	const handleChangeConsigneeDetail = (evnt) => {
		if (evnt.target.checked && consigneeDetails) {
			const fullPhone = awbConsigneeDetails.consigneePhone || '';
			let code = '';
			let phone = '';

			if (fullPhone.includes('-')) {
				[code, phone] = fullPhone.split('-');
			} else {
				phone = fullPhone;
			}

			setConsigneeDetails({
				...consigneeDetails,
				consigneeName: awbConsigneeDetails.consigneeName,
				consigneeAddress1: awbConsigneeDetails.consigneeAddress1,
				consigneeCity: awbConsigneeDetails.consigneeCity,
				consigneeState: awbConsigneeDetails.consigneeState,
				consigneeCountry: awbConsigneeDetails.consigneeCountry,
				consigneePostalCode: awbConsigneeDetails.consigneePostalCode,
				consigneeAccountNumber: awbConsigneeDetails.consigneeAccountNumber,
				consigneePhone: awbConsigneeDetails.consigneePhone,
				consigneeMail: awbConsigneeDetails.consigneeMail,
				phContryCode: awbConsigneeDetails.phContryCode,
			})
			checkConsigneeValidations()
		} else if (!evnt.target.checked && existingHawbConsigneeDetails !== null) {
			setConsigneeDetails({ ...existingHawbConsigneeDetails })
			checkConsigneeValidations()
		} else {
			setConsigneeDetails({ ...initialStateConsigneeDetails })
		}
	}

	const checkConsigneeValidations = () => {
		setError((prevState) => ({ ...prevState, 'consigneeName': '' }))
		setError((prevState) => ({ ...prevState, 'consigneeAddress': '' }))
		setError((prevState) => ({ ...prevState, 'consigneeCity': '' }))
		setError((prevState) => ({ ...prevState, 'consigneeCountry': '' }))
		validateParticipants(awbShipperDetails, awbConsigneeDetails, setError)
	}


	return (
		<div className={`participant-details-wrapper ${isRTL ? 'rtl' : ''}`}>
			<div className='portal-row '>
				<div className='portal-col'>
					<h4 className='page-sub-title mt-0 mb-0'>{t('CAPTURE_AWB.PAR_DTLS')}</h4>
				</div>
			</div>
	
		  <div className='hawb-participant-details-wrapper'>
		  <div className='portal-row hawb-shipper-head-section'>	
			<div className='portal-col'>
					<p className='participant-sub-title mb-0'>{t('CAPTURE_AWB.SHP_DTLS')}</p>
				</div>
			<div className='portal-row hawb-shipper-details-section'>
				<div className='shipping-deparr-row-checkbox'>
					<div className='portal-row'>
						<div className='portal-col'>
							<div
								className='l-checkbox'
								// data-module='molecules/form-item/FormItem'
							>
								<input
									id={`${isExpanded
										? 'expanded-shipper-same-as-Awb'
										: 'addAnother-shipper-same-as-Awb'
										}  `}
									// checked={privileges.bookingPrivilege}
									// value={privileges.bookingPrivilege}
									type='checkbox'
									name={`${isExpanded
										? 'expanded-shipper-same-as-Awb'
										: 'addAnother-shipper-same-as-Awb'
										}  `}
									className=''
									onChange={(evnt) => handleChangeShipperDetail(evnt)}
								/>
								<label
									htmlFor={`${isExpanded
										? 'expanded-shipper-same-as-Awb'
										: 'addAnother-shipper-same-as-Awb'
										}  `}
									className='form-item__label'
								>
									{t('CAPTURE_HAWB.S_A_AWB')}
								</label>
							</div>
						</div>
					</div>
				</div>

				<div className='shipping-deparr-row'>

					<div
						className={`form-group ${hasError('shipperName', error) ? "red-border" : ""
							}`}
					>
						<CommonInput
							id='shipperName'
							name='shipperName'
							type='text'
							label={t('CAPTURE_AWB.NAME')}
							maxLength='70'
							value={shipperDetails.shipperName ? shipperDetails.shipperName.toUpperCase() : ''}
							onChange={(e) => {
								setShipperDetails({
									...shipperDetails,
									shipperName: e.target.value,
								})
							}}
							onBlur={(e) => {
								validateNameRequired(
									e.target.value,
									setError,
									'shipperName',
									'Name'
								)
							}}
							aria-invalid={hasError('shipperName', error)}
							onFocus={(e) => {
								removeError(e, setError)
							}}
							error={error && error['shipperName']
								? t(error['shipperName'], { ns: 'errors' })
								: ''}
						/>
					</div>

					{/* <div className='form-row mt-4 mb-2 mb-lg-3'>
						<div
							className='col-12 form-item form-item--text'
							data-module='molecules/form-item/FormItem'
						>
							<label className='form-item__label' htmlFor='shipperName'>
								{' '}
								{t('COMMON.NAME')}
							</label>
							<input
								id='shipperName'
								name='shipperName'
								type='text'
								className='form-item__field'
								placeholder='Name'
								maxLength='70'
								value={shipperDetails.shipperName ? shipperDetails.shipperName.toUpperCase(): ''}
								onChange={(e) => {
									setShipperDetails({
										...shipperDetails,
										shipperName: e.target.value,
									})
								}}
								onBlur={(e) => {
									validateNameRequired(
										e.target.value,
										setError,
										'shipperName',
										'Name'
									)
								}}
								aria-invalid={hasError('shipperName', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
							/>
							<span className='form-item__error'>
								{error && error['shipperName']
									? t(error['shipperName'], { ns: 'errors' })
									: ''}
							</span>
						</div>
					</div> */}

					<div
						className={`form-group ${hasError('shipperAddress', error) ? "red-border" : ""
							}`}
					>
						<CommonInput
							id='shipperAddress'
							name='shipperAddress'
							type='text'
							label={t('CAPTURE_AWB.ADDRS')}
							maxLength='70'
							value={shipperDetails.shipperAddress1 ? shipperDetails.shipperAddress1.toUpperCase() : ''}
							onChange={(e) => {
								setShipperDetails({
									...shipperDetails,
									shipperAddress1: e.target.value,
								})
							}}
							onBlur={(e) => {
								validateRequired(
									e.target.value,
									setError,
									'shipperAddress',
									t('CAPTURE_AWB.ADDRS')
								)
							}}
							aria-invalid={hasError('shipperAddress', error)}
							onFocus={(e) => {
								removeError(e, setError)
							}}
							error={error && error['shipperAddress']
								? t(error['shipperAddress'], { ns: 'errors' })
								: ''}
						/>
					</div>

					{/* <div className='form-row mt-lg-4 mb-2 mb-lg-3'>
						<div
							className='col-12 form-item form-item--text'
							data-module='molecules/form-item/FormItem'
						>
							<label className='form-item__label' htmlFor='shipperAddress'>
								{t('COMMON.ADDRS')}
							</label>
							<input
								id='shipperAddress'
								name='shipperAddress'
								type='text'
								className='form-item__field'
								placeholder='Address'
								maxLength='70'
								value={shipperDetails.shipperAddress1 ? shipperDetails.shipperAddress1.toUpperCase() : ''}
								onChange={(e) => {
									setShipperDetails({
										...shipperDetails,
										shipperAddress1: e.target.value,
									})
								}}
								onBlur={(e) => {
									validateRequired(
										e.target.value,
										setError,
										'shipperAddress',
										t('COMMON.ADDRS')
									)
								}}
								aria-invalid={hasError('shipperAddress', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
							/>
							<span className='form-item__error'>
								{error && error['shipperAddress']
									? t(error['shipperAddress'], { ns: 'errors' })
									: ''}
							</span>
						</div>
					</div> */}
				</div>

				<div className='shipping-deparr-row'>
					<div
						className={`form-group ${hasError('shipperCity', error) ? "red-border" : ""
							}`}
					>
						<CommonInput
							id='shipperCity'
							name='shipperCity'
							type='text'
							label={t('CAPTURE_AWB.CITY')}
							maxLength='70'
							value={shipperDetails.shipperCity ? shipperDetails.shipperCity.toUpperCase() : ''}
							onChange={(e) => {
								setShipperDetails({
									...shipperDetails,
									shipperCity: e.target.value,
								})
							}}
							onBlur={(e) => {
								validateRequired(
									e.target.value,
									setError,
									'shipperCity',
									t('CAPTURE_AWB.CITY')
								)
							}}
							aria-invalid={hasError('shipperCity', error)}
							onFocus={(e) => {
								removeError(e, setError)
							}}
							error={error && error['shipperCity']
								? t(error['shipperCity'], { ns: 'errors' })
								: ''}
						/>
					</div>

					{/* <div className='form-row mt-lg-4 mb-2 mb-lg-3'>
						<div
							className='col-12 form-item form-item--text'
							data-module='molecules/form-item/FormItem'
						>
							<label className='form-item__label' htmlFor='shipperCity'>
								{t('COMMON.CITY')}
							</label>
							<input
								id='shipperCity'
								name='shipperCity'
								type='text'
								className='form-item__field'
								placeholder='City'
								maxLength='70'
								value={shipperDetails.shipperCity ? shipperDetails.shipperCity.toUpperCase():''}
								onChange={(e) => {
									setShipperDetails({
										...shipperDetails,
										shipperCity: e.target.value,
									})
								}}
								onBlur={(e) => {
									validateRequired(
										e.target.value,
										setError,
										'shipperCity',
										t('COMMON.CITY')
									)
								}}
								aria-invalid={hasError('shipperCity', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
							/>
							<span className='form-item__error'>
								{error && error['shipperCity']
									? t(error['shipperCity'], { ns: 'errors' })
									: ''}
							</span>
						</div>
					</div> */}


					<div
						className={`form-group ${hasError('shipperState', error) ? "red-border" : ""
							}`}
					>
						<CommonInput
							id='shipperState'
							name='shipperState'
							type='text'
							label={t('CAPTURE_AWB.STATE')}
							maxLength='70'
							value={shipperDetails.shipperState ? shipperDetails.shipperState.toUpperCase() : ''}
							onChange={(e) => {
								setShipperDetails({
									...shipperDetails,
									shipperState: e.target.value,
								})
							}}
							onBlur={(e) => {
								validateAlphaIfPresent(
									e.target.value,
									setError,
									'shipperState'
								)
							}}
							aria-invalid={hasError('shipperState', error)}
							onFocus={(e) => {
								removeError(e, setError)
							}}
							error={error && error['shipperState']
								? t(error['shipperState'], { ns: 'errors' })
								: ''}
						/>
					</div>


					{/* <div className='form-row mt-lg-4 mb-2 mb-lg-3'>
						<div
							className='col-12 form-item form-item--text'
							data-module='molecules/form-item/FormItem'
						>
							<label className='form-item__label' htmlFor='shipperState'>
								{t('COMMON.STATE')}
							</label>
							<input
								id='shipperState'
								name='shipperState'
								type='text'
								className='form-item__field'
								placeholder='State'
								maxLength='70'
								value={shipperDetails.shipperState ? shipperDetails.shipperState.toUpperCase(): ''}
								onChange={(e) => {
									setShipperDetails({
										...shipperDetails,
										shipperState: e.target.value,
									})
								}}
								onBlur={(e) => {
									validateAlphaIfPresent(
										e.target.value,
										setError,
										'shipperState'
									)
								}}
								aria-invalid={hasError('shipperState', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
							/>
							<span className='form-item__error'>
								{error && error['shipperState']
									? t(error['shipperState'], { ns: 'errors' })
									: ''}
							</span>
						</div>
					</div> */}

				</div>

				<div className='shipping-deparr-row'>
					<div
						className={`form-group common-autocomplete country-autocomplete-capture ${hasError('shipperCountry', error) ? "red-border" : ""
							}`}
					>
						<div className="p-float-label input-wrapper">
							<CountryAutocomplete
								autoCompleteType={AUTOCOMPLETE_TYPE_COUNTRY.SHIPPER}
								selectedShipperCountry={shipperDetails.shipperCountry}
								selectedCosigneeCountry={consigneeDetails.consigneeCountry}
								setSelectedShipperCountry={setSelectedShipperCountry}
								isMandatory={true}
								setError={setError}
							/>
							<label htmlFor="shipperCountry">
								{t("CAPTURE_AWB.CNTRY")}
							</label>
						</div>
						<span className="search-panel__errormsg">
							{error && error['shipperCountry']
								? t(error['shipperCountry'], { ns: 'errors' })
								: ''}
						</span>
					</div>

					{/* <div className='form-row mt-lg-4 mb-2 mb-lg-3'>
						<div
							className={`col-12 form-item form-item--text ${
								hasError('shipperCountry', error) ? 'red-border' : ''
							}`}
						>
							<label className='form-item__label' htmlFor='shipperCountry'>
								{t('COMMON.CNTRY')}
							</label>
							<CountryAutocomplete
								autoCompleteType={AUTOCOMPLETE_TYPE_COUNTRY.SHIPPER}
								selectedShipperCountry={shipperDetails.shipperCountry}
								selectedCosigneeCountry={consigneeDetails.consigneeCountry}
								setSelectedShipperCountry={setSelectedShipperCountry}
								isMandatory={true}
								setError={setError}
							/>
							<span className='form-item__error'>
								{error && error['shipperCountry']
									? t(error['shipperCountry'], { ns: 'errors' })
									: ''}
							</span>
						</div>
					</div> */}

					<div
						className={`form-group ${hasError('shipperZipCode', error) ? "red-border" : ""
							}`}
					>
						<CommonInput
							id='shipperZipCode'
							name='shipperZipCode'
							type='text'
							label={t('CAPTURE_AWB.ZIP_CODE')}
							maxLength='10'
							value={shipperDetails.shipperPostalCode ? shipperDetails.shipperPostalCode.toUpperCase() : ''}
							onChange={(e) => {
								setShipperDetails({
									...shipperDetails,
									shipperPostalCode: e.target.value,
								})
							}}
							onBlur={(e) => {
								validatePostalCodeIfPresent(
									e.target.value,
									setError,
									'shipperZipCode'
								)
							}}
							aria-invalid={hasError('shipperZipCode', error)}
							onFocus={(e) => {
								removeError(e, setError)
							}}
							error={error && error['shipperZipCode']
								? t(error['shipperZipCode'], { ns: 'errors' })
								: ''}
						/>
					</div>

					{/* <div className='form-row mt-lg-4 mb-2 mb-lg-3'>
						<div
							className='col-12 form-item form-item--text'
							data-module='molecules/form-item/FormItem'
						>
							<label className='form-item__label' htmlFor='shipperZipCode'>
								{t('COMMON.ZIP_CODE')}
							</label>
							<input
								id='shipperZipCode'
								name='shipperZipCode'
								type='text'
								className='form-item__field'
								placeholder='Zip code'
								maxLength='10'
								value={shipperDetails.shipperPostalCode ? shipperDetails.shipperPostalCode.toUpperCase() :''}
								onChange={(e) => {
									setShipperDetails({
										...shipperDetails,
										shipperPostalCode: e.target.value,
									})
								}}
								onBlur={(e) => {
									validatePostalCodeIfPresent(
										e.target.value,
										setError,
										'shipperZipCode'
									)
								}}
								aria-invalid={hasError('shipperZipCode', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
							/>
							<span className='form-item__error'>
								{error && error['shipperZipCode']
									? t(error['shipperZipCode'], { ns: 'errors' })
									: ''}
							</span>
						</div>
					</div> */}

				</div>
				{/**  To remove Account number field from HAWB screen. */}
				{/* <div className='form-row mt-lg-4 mb-2 mb-lg-3'>
						<div
							className='col-12 form-item form-item--text'
							data-module='molecules/form-item/FormItem'
						>
							<label
								className='form-item__label'
								htmlFor='shipperAccountNumber'
							>
								{t('COMMON.ACCNT_NO')}
							</label>
							<input
								id='shipperAccountNumber'
								name='shipperAccountNumber'
								type='text'
								className='form-item__field'
								placeholder='Account number'
								maxLength='14'
								value={shipperDetails.shipperAccountNumber ? shipperDetails.shipperAccountNumber.toUpperCase(): ''}
								onChange={(e) => {
									setShipperDetails({
										...shipperDetails,
										shipperAccountNumber: e.target.value,
									})
								}}
								onBlur={(e) => {
									validateAlphaNumericIfPresent(
										e.target.value,
										setError,
										'shipperAccountNumber'
									)
								}}
								aria-invalid={hasError('shipperAccountNumber', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
							/>
							<span className='form-item__error'>
								{error && error['shipperAccountNumber']
									? t(error['shipperAccountNumber'], { ns: 'errors' })
									: ''}
							</span>
						</div>
					</div> */}

				<div className='shipping-deparr-row'>

					<div className="combined-phone-input d-flex align-items-end" data-module="molecules/form-item/FormItem">
						<div className={`country-dropdown-wrapper ${error && error['phContryCode'] ? 'red-border' : ''}`}>
							<CountryCodeDropdown
								id="phContryCode"
								name="phContryCode"
								countryCodes={sortedCountryCodes}
								userCountryCode={shipperDetails.phContryCode?.code || ''}
								setCountryCode={(codeObj) => {
									setShipperDetails((prevDetails) => ({
										...prevDetails,
										phContryCode: codeObj
									}));
									triggerPhoneCodeValidation(codeObj.code);
								}}
								triggerCodeValidation={triggerPhoneCodeValidation}
								setError={setError}
								removeError={removeError}
							/>
							<span className="form-item__error">
								{error && error['phContryCode']
									? t(error['phContryCode'], { ns: 'errors' })
									: ''}
							</span>
						</div>
						<div className="form-group flex-grow-1 phone-input-wrapper">
							{/* <CommonInput
								type="text"
								id="shipperTelephone"
								name="shipperTelephone"
								label={t('COMMON.TEL_HEAD')}
								maxLength="35"
								{...bindPhoneNumber}
								onBlur={handlePhoneBlur}
								aria-invalid={hasError('shipperTelephone', error)}
								onFocus={(e) => {
									removeError(e, setError);
								}}
								error={error && error['shipperTelephone'] ? t(error['shipperTelephone'], { ns: 'errors' }) : ''}
							/> */}
							<CommonInput
								type="text"
								id="shipperTelephone"
								name="shipperTelephone"
								label={t('CAPTURE_AWB.TEL_HEAD')}
								maxLength={35}
								value={shipperDetails.shipperPhone ? shipperDetails.shipperPhone.toUpperCase() : ''}
								onChange={(e) => {
									setShipperDetails({
										...shipperDetails,
										shipperPhone: e.target.value,
									});
								}}
								onBlur={(e) => {
									validatePhoneNumberIfPresent(
										e.target.value,
										setError,
										'shipperTelephone'
									);
								}}
								aria-invalid={hasError('shipperTelephone', error)}
								onFocus={(e) => {
									removeError(e, setError);
								}}
								error={
									error && error['shipperTelephone']
										? t(error['shipperTelephone'], { ns: 'errors' })
										: ''
								}
							/>

						</div>
					</div>


					{/* <div className='form-row mt-lg-4 mb-2 mb-lg-3'>
						<div
							className='col-12 form-item form-item--text'
							data-module='molecules/form-item/FormItem'
						>
							<label className='form-item__label' htmlFor='shipperTelephone'>
								{t('COMMON.TEL_HEAD')}
							</label>
							<input
								id='shipperTelephone'
								name='shipperTelephone'
								type='text'
								className='form-item__field'
								placeholder='Telephone'
								maxLength='35'
								value={shipperDetails.shipperPhone ? shipperDetails.shipperPhone.toUpperCase(): ''}
								onChange={(e) => {
									setShipperDetails({
										...shipperDetails,
										shipperPhone: e.target.value,
									})
								}}
								onBlur={(e) => {
									validatePhoneNumberIfPresent(
										e.target.value,
										setError,
										'shipperTelephone'
									)
								}}
								aria-invalid={hasError('shipperTelephone', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
							/>
							<span className='form-item__error'>
								{error && error['shipperTelephone']
									? t(error['shipperTelephone'], { ns: 'errors' })
									: ''}
							</span>
						</div>
					</div> */}

					<div
						className={`form-group ${hasError('shipperEmail', error) ? "red-border" : ""
							}`}
					>
						<CommonInput
							id='shipperEmail'
							name='shipperEmail'
							type='text'
							label={t('CAPTURE_AWB.EMAIL_HEAD')}
							maxLength='70'
							value={shipperDetails.shipperMail ? shipperDetails.shipperMail.toUpperCase() : ''}
							onChange={(e) => {
								setShipperDetails({
									...shipperDetails,
									shipperMail: e.target.value,
								})
							}}
							onBlur={(e) => {
								validateEmailIfPresent(
									e.target.value,
									setError,
									'shipperEmail'
								)
							}}
							aria-invalid={hasError('shipperEmail', error)}
							onFocus={(e) => {
								removeError(e, setError)
							}}
							error={error && error['shipperEmail']
								? t(error['shipperEmail'], { ns: 'errors' })
								: ''}
						/>
					</div>

					{/* <div className='form-row mt-lg-4 mb-3'>
						<div
							className='col-12 form-item form-item--text'
							data-module='molecules/form-item/FormItem'
						>
							<label className='form-item__label' htmlFor='shipperEmail'>
								{t('COMMON.EMAIL_HEAD')}
							</label>
							<input
								id='shipperEmail'
								name='shipperEmail'
								type='text'
								className='form-item__field'
								placeholder='Email address'
								maxLength='70'
								value={shipperDetails.shipperMail ? shipperDetails.shipperMail.toUpperCase():''}
								onChange={(e) => {
									setShipperDetails({
										...shipperDetails,
										shipperMail: e.target.value,
									})
								}}
								onBlur={(e) => {
									validateEmailIfPresent(
										e.target.value,
										setError,
										'shipperEmail'
									)
								}}
								aria-invalid={hasError('shipperEmail', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
							/>
							<span className='form-item__error'>
								{error && error['shipperEmail']
									? t(error['shipperEmail'], { ns: 'errors' })
									: ''}
							</span>
						</div>
					</div> */}

				</div>

			</div>
		  </div>	
		  <div className='portal-row hawb-consignee-head-section'>
			<div className='portal-col'>
			<p className=' participant-sub-title mb-0'>{t('CAPTURE_AWB.CON_DTLS')}</p>
             </div>
			<div className='portal-row hawb-consignee-details-section'>

				<div className='shipping-deparr-row-checkbox'>
					<div className='portal-row'>
						<div className='portal-col'>
							<div
								className='l-checkbox'
								data-module='molecules/form-item/FormItem'
							>
								<input
									id={`${isExpanded
										? 'expanded-consignee-same-as-Awb'
										: 'addAnother-consignee-same-as-Awb'
										}  `}
									type='checkbox'
									name={`${isExpanded
										? 'expanded-consignee-same-as-Awb'
										: 'addAnother-consignee-same-as-Awb'
										}  `}
									className=''
									onChange={(evnt) => handleChangeConsigneeDetail(evnt)}
								/>
								<label
									htmlFor={`${isExpanded
										? 'expanded-consignee-same-as-Awb'
										: 'addAnother-consignee-same-as-Awb'
										}  `}
									className='form-item__label'
								>
									{t('CAPTURE_HAWB.S_A_AWB')}
								</label>
							</div>
						</div>
					</div>
				</div>
				<div className='shipping-deparr-row'>

					<div
						className={`form-group ${hasError('consigneeName', error) ? "red-border" : ""
							}`}
					>
						<CommonInput
							id='consigneeName'
							name='consigneeName'
							type='text'
							label={t('CAPTURE_AWB.NAME')}
							maxLength='70'
							value={consigneeDetails.consigneeName ? consigneeDetails.consigneeName.toUpperCase() : ''}
							onChange={(e) => {
								setConsigneeDetails({
									...consigneeDetails,
									consigneeName: e.target.value,
								})
							}}
							onBlur={(e) => {
								validateNameRequired(
									e.target.value,
									setError,
									'consigneeName',
									'Name'
								)
							}}
							aria-invalid={hasError('consigneeName', error)}
							onFocus={(e) => {
								removeError(e, setError)
							}}
							error={error && error['consigneeName']
								? t(error['consigneeName'], { ns: 'errors' })
								: ''}
						/>
					</div>

					{/* <div className='form-row mt-4 mb-2 mb-lg-3'>
						<div
							className='col-12 form-item form-item--text'
							data-module='molecules/form-item/FormItem'
						>
							<label className='form-item__label' htmlFor='consigneeName'>
								{t('COMMON.NAME')}
							</label>
							<input
								id='consigneeName'
								name='consigneeName'
								type='text'
								className='form-item__field'
								placeholder='Name'
								maxLength='70'
								value={consigneeDetails.consigneeName ? consigneeDetails.consigneeName.toUpperCase() : ''}
								onChange={(e) => {
									setConsigneeDetails({
										...consigneeDetails,
										consigneeName: e.target.value,
									})
								}}
								onBlur={(e) => {
									validateNameRequired(
										e.target.value,
										setError,
										'consigneeName',
										'Name'
									)
								}}
								aria-invalid={hasError('consigneeName', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
							/>
							<span className='form-item__error'>
								{error && error['consigneeName']
									? t(error['consigneeName'], { ns: 'errors' })
									: ''}
							</span>
						</div>
					</div> */}


					<div
						className={`form-group ${hasError('consigneeAddress', error) ? "red-border" : ""
							}`}
					>
						<CommonInput
							id='consigneeAddress'
							name='consigneeAddress'
							type='text'
							label={t('CAPTURE_AWB.ADDRS')}
							maxLength='70'
							value={consigneeDetails.consigneeAddress1 ? consigneeDetails.consigneeAddress1.toUpperCase() : ''}
							onChange={(e) => {
								setConsigneeDetails({
									...consigneeDetails,
									consigneeAddress1: e.target.value,
								})
							}}
							onBlur={(e) => {
								validateRequired(
									e.target.value,
									setError,
									'consigneeAddress',
									t('CAPTURE_AWB.ADDRS')
								)
							}}
							aria-invalid={hasError('consigneeAddress', error)}
							onFocus={(e) => {
								removeError(e, setError)
							}}
							error={error && error['consigneeAddress']
								? t(error['consigneeAddress'], { ns: 'errors' })
								: ''}
						/>
					</div>

					{/* <div className='form-row mt-lg-4 mb-2 mb-lg-3'>
						<div
							className='col-12 form-item form-item--text'
							data-module='molecules/form-item/FormItem'
						>
							<label className='form-item__label' htmlFor='consigneeAddress'>
								{t('COMMON.ADDRS')}
							</label>
							<input
								id='consigneeAddress'
								name='consigneeAddress'
								type='text'
								className='form-item__field'
								placeholder='Address'
								maxLength='70'
								value={consigneeDetails.consigneeAddress1 ? consigneeDetails.consigneeAddress1.toUpperCase(): ''}
								onChange={(e) => {
									setConsigneeDetails({
										...consigneeDetails,
										consigneeAddress1: e.target.value,
									})
								}}
								onBlur={(e) => {
									validateRequired(
										e.target.value,
										setError,
										'consigneeAddress',
										t('COMMON.ADDRS')
									)
								}}
								aria-invalid={hasError('consigneeAddress', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
							/>
							<span className='form-item__error'>
								{error && error['consigneeAddress']
									? t(error['consigneeAddress'], { ns: 'errors' })
									: ''}
							</span>
						</div>
					</div> */}
				</div>

				<div className='shipping-deparr-row'>

					<div
						className={`form-group ${hasError('consigneeCity', error) ? "red-border" : ""
							}`}
					>
						<CommonInput
							id='consigneeCity'
							name='consigneeCity'
							type='text'
							label={t('CAPTURE_AWB.CITY')}
							maxLength='70'
							value={consigneeDetails.consigneeCity ? consigneeDetails.consigneeCity.toUpperCase() : ''}
							onChange={(e) => {
								setConsigneeDetails({
									...consigneeDetails,
									consigneeCity: e.target.value,
								})
							}}
							onBlur={(e) => {
								validateRequired(
									e.target.value,
									setError,
									'consigneeCity',
									t('CAPTURE_AWB.CITY')
								)
							}}
							aria-invalid={hasError('consigneeCity', error)}
							onFocus={(e) => {
								removeError(e, setError)
							}}
							error={error && error['consigneeCity']
								? t(error['consigneeCity'], { ns: 'errors' })
								: ''}
						/>
					</div>
					{/* <div className='form-row mt-lg-4 mb-2 mb-lg-3'>
						<div
							className='col-12 form-item form-item--text'
							data-module='molecules/form-item/FormItem'
						>
							<label className='form-item__label' htmlFor='consigneeCity'>
								{t('COMMON.CITY')}
							</label>
							<input
								id='consigneeCity'
								name='consigneeCity'
								type='text'
								className='form-item__field'
								placeholder='City'
								maxLength='70'
								value={consigneeDetails.consigneeCity ? consigneeDetails.consigneeCity.toUpperCase(): ''}
								onChange={(e) => {
									setConsigneeDetails({
										...consigneeDetails,
										consigneeCity: e.target.value,
									})
								}}
								onBlur={(e) => {
									validateRequired(
										e.target.value,
										setError,
										'consigneeCity',
										t('COMMON.CITY')
									)
								}}
								aria-invalid={hasError('consigneeCity', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
							/>
							<span className='form-item__error'>
								{error && error['consigneeCity']
									? t(error['consigneeCity'], { ns: 'errors' })
									: ''}
							</span>
						</div>
					</div> */}
					<div
						className={`form-group ${hasError('consigneeState', error) ? "red-border" : ""
							}`}
					>
						<CommonInput
							id='consigneeState'
							name='consigneeState'
							type='text'
							label={t('CAPTURE_AWB.STATE')}
							maxLength='70'
							value={consigneeDetails.consigneeState ? consigneeDetails.consigneeState.toUpperCase() : ''}
							onChange={(e) => {
								setConsigneeDetails({
									...consigneeDetails,
									consigneeState: e.target.value,
								})
							}}
							onBlur={(e) => {
								validateAlphaIfPresent(
									e.target.value,
									setError,
									'consigneeState'
								)
							}}
							aria-invalid={hasError('consigneeState', error)}
							onFocus={(e) => {
								removeError(e, setError)
							}}
							error={error && error['consigneeState']
								? t(error['consigneeState'], { ns: 'errors' })
								: ''}
						/>
					</div>
					{/* <div className='form-row mt-lg-4 mb-2 mb-lg-3'>
						<div
							className='col-12 form-item form-item--text'
							data-module='molecules/form-item/FormItem'
						>
							<label className='form-item__label' htmlFor='consigneeState'>
								{t('COMMON.STATE')}
							</label>
							<input
								id='consigneeState'
								name='consigneeState'
								type='text'
								className='form-item__field'
								placeholder='State'
								maxLength='70'
								value={consigneeDetails.consigneeState ? consigneeDetails.consigneeState.toUpperCase() : ''}
								onChange={(e) => {
									setConsigneeDetails({
										...consigneeDetails,
										consigneeState: e.target.value,
									})
								}}
								onBlur={(e) => {
									validateAlphaIfPresent(
										e.target.value,
										setError,
										'consigneeState'
									)
								}}
								aria-invalid={hasError('consigneeState', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
							/>
							<span className='form-item__error'>
								{error && error['consigneeState']
									? t(error['consigneeState'], { ns: 'errors' })
									: ''}
							</span>
						</div>
					</div> */}
				</div>

				<div className='shipping-deparr-row'>

					<div
						className={`form-group common-autocomplete country-autocomplete-capture ${hasError('consigneeCountry', error) ? "red-border" : ""
							}`}
					>
						<div className="p-float-label input-wrapper">
							<CountryAutocomplete
								autoCompleteType={AUTOCOMPLETE_TYPE_COUNTRY.CONSIGNEE}
								selectedShipperCountry={shipperDetails.shipperCountry}
								selectedCosigneeCountry={consigneeDetails.consigneeCountry}
								setSelectedCosigneeCountry={setSelectedCosigneeCountry}
								isMandatory={true}
								setError={setError}
							/>
							<label htmlFor="shipperCountry">
								{t("CAPTURE_AWB.CNTRY")}
							</label>
						</div>
						<span className="search-panel__errormsg">
							{error && error['consigneeCountry']
								? t(error['consigneeCountry'], { ns: 'errors' })
								: ''}
						</span>
					</div>

					{/* <div className='form-row mt-lg-4 mb-2 mb-lg-3'>
						<div
							className={`col-12 form-item form-item--text ${
								hasError('consigneeCountry', error) ? 'red-border' : ''
							}`}
						>
							<label className='form-item__label' htmlFor='consigneeCountry'>
								{t('COMMON.CNTRY')}
							</label>
							<CountryAutocomplete
								autoCompleteType={AUTOCOMPLETE_TYPE_COUNTRY.CONSIGNEE}
								selectedShipperCountry={shipperDetails.shipperCountry}
								selectedCosigneeCountry={consigneeDetails.consigneeCountry}
								setSelectedCosigneeCountry={setSelectedCosigneeCountry}
								isMandatory={true}
								setError={setError}
							/>
							<span className='form-item__error'>
								{error && error['consigneeCountry']
									? t(error['consigneeCountry'], { ns: 'errors' })
									: ''}
							</span>
						</div>
					</div> */}

					<div
						className={`form-group ${hasError('consigneeZipCode', error) ? "red-border" : ""
							}`}
					>
						<CommonInput
							id='consigneeZipCode'
							name='consigneeZipCode'
							type='text'
							label={t('CAPTURE_AWB.ZIP_CODE')}
							maxLength='10'
							value={consigneeDetails.consigneePostalCode ? consigneeDetails.consigneePostalCode.toUpperCase() : ''}
							onChange={(e) => {
								setConsigneeDetails({
									...consigneeDetails,
									consigneePostalCode: e.target.value,
								})
							}}
							onBlur={(e) => {
								validatePostalCodeIfPresent(
									e.target.value,
									setError,
									'consigneeZipCode'
								)
							}}
							aria-invalid={hasError('consigneeZipCode', error)}
							onFocus={(e) => {
								removeError(e, setError)
							}}
							error={error && error['consigneeZipCode']
								? t(error['consigneeZipCode'], { ns: 'errors' })
								: ''}
						/>
					</div>

					{/* <div className='form-row mt-lg-4 mb-2 mb-lg-3'>
						<div
							className='col-12 form-item form-item--text'
							data-module='molecules/form-item/FormItem'
						>
							<label className='form-item__label' htmlFor='consigneeZipCode'>
								{t('COMMON.ZIP_CODE')}
							</label>
							<input
								id='consigneeZipCode'
								name='consigneeZipCode'
								type='text'
								className='form-item__field'
								placeholder='Zip code'
								maxLength='10'
								value={consigneeDetails.consigneePostalCode ? consigneeDetails.consigneePostalCode.toUpperCase(): ''}
								onChange={(e) => {
									setConsigneeDetails({
										...consigneeDetails,
										consigneePostalCode: e.target.value,
									})
								}}
								onBlur={(e) => {
									validatePostalCodeIfPresent(
										e.target.value,
										setError,
										'consigneeZipCode'
									)
								}}
								aria-invalid={hasError('consigneeZipCode', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
							/>
							<span className='form-item__error'>
								{error && error['consigneeZipCode']
									? t(error['consigneeZipCode'], { ns: 'errors' })
									: ''}
							</span>
						</div>
					</div> */}

				</div>
				{/**  To remove Account number field from HAWB screen. */}
				{/* <div className='form-row mt-lg-4 mb-2 mb-lg-3'>
						<div
							className='col-12 form-item form-item--text'
							data-module='molecules/form-item/FormItem'
						>
							<label
								className='form-item__label'
								htmlFor='consigneeAccountNumber'
							>
								{t('COMMON.ACCNT_NO')}
							</label>
							<input
								id='consigneeAccountNumber'
								name='consigneeAccountNumber'
								type='text'
								className='form-item__field'
								placeholder='Account number'
								maxLength='14'
								value={consigneeDetails.consigneeAccountNumber ? consigneeDetails.consigneeAccountNumber.toUpperCase() : ''}
								onChange={(e) => {
									setConsigneeDetails({
										...consigneeDetails,
										consigneeAccountNumber: e.target.value,
									})
								}}
								onBlur={(e) => {
									validateAlphaNumericIfPresent(
										e.target.value,
										setError,
										'consigneeAccountNumber'
									)
								}}
								aria-invalid={hasError('consigneeAccountNumber', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
							/>
							<span className='form-item__error'>
								{error && error['consigneeAccountNumber']
									? t(error['consigneeAccountNumber'], { ns: 'errors' })
									: ''}
							</span>
						</div>
					</div> */}

				<div className='shipping-deparr-row'>

					<div className="combined-phone-input d-flex align-items-end" data-module="molecules/form-item/FormItem">
						<div className={`country-dropdown-wrapper ${error && error['consigneePhContryCode'] ? 'red-border' : ''}`}>
							<CountryCodeDropdown
								id="consigneePhContryCode"
								name="consigneePhContryCode"
								countryCodes={sortedCountryCodes}
							    userCountryCode={consigneeDetails.phContryCode?.code || ''}
								setCountryCode={(codeObj) => {
									setConsigneeDetails((prevDetails) => ({
										...prevDetails,
										phContryCode: codeObj
									}));
									triggerPhoneCodeValidation(codeObj.code);
								}}
								triggerCodeValidation={triggerConsigneePhoneCodeValidation}
								setError={setError}
								removeError={removeError}
							/>
							<span className="form-item__error">
								{error && error['consigneePhContryCode']
									? t(error['consigneePhContryCode'], { ns: 'errors' })
									: ''}
							</span>
						</div>
						<div className="form-group flex-grow-1 phone-input-wrapper">
							{/* <CommonInput
								type="text"
								id="consigneeTelephone"
								name="consigneeTelephone"
								label={t('COMMON.TEL_HEAD')}
								maxLength="35"
								{...bindConsigneePhoneNumber}
								onBlur={handleConsigneePhoneBlur}
								aria-invalid={hasError('consigneeTelephone', error)}
								onFocus={e => removeError(e, setError)}
								error={error && error['consigneeTelephone'] ? t(error['consigneeTelephone'], { ns: 'errors' }) : ''}
							/> */}
							<CommonInput
								type="text"
								id="consigneeTelephone"
								name="consigneeTelephone"
								label={t('CAPTURE_AWB.TEL_HEAD')}
								maxLength={35}
								value={consigneeDetails.consigneePhone ? consigneeDetails.consigneePhone.toUpperCase() : ''}
								onChange={e => {
									setConsigneeDetails({
										...consigneeDetails,
										consigneePhone: e.target.value,
									});
								}}
								onBlur={e => {
									validatePhoneNumberIfPresent(
										e.target.value,
										setError,
										'consigneeTelephone'
									);
								}}
								aria-invalid={hasError('consigneeTelephone', error)}
								onFocus={e => removeError(e, setError)}
								error={
									error && error['consigneeTelephone']
										? t(error['consigneeTelephone'], { ns: 'errors' })
										: ''
								}
							/>

						</div>
					</div>

					{/* <div className='form-row mt-lg-4 mb-2 mb-lg-3'>
						<div
							className='col-12 form-item form-item--text'
							data-module='molecules/form-item/FormItem'
						>
							<label className='form-item__label' htmlFor='consigneeTelephone'>
								{t('COMMON.TEL_HEAD')}
							</label>
							<input
								id='consigneeTelephone'
								name='consigneeTelephone'
								type='text'
								className='form-item__field'
								placeholder='Telephone'
								maxLength='35'
								value={consigneeDetails.consigneePhone ? consigneeDetails.consigneePhone.toUpperCase() : ''}
								onChange={(e) => {
									setConsigneeDetails({
										...consigneeDetails,
										consigneePhone: e.target.value,
									})
								}}
								onBlur={(e) => {
									validatePhoneNumberIfPresent(
										e.target.value,
										setError,
										'consigneeTelephone'
									)
								}}
								aria-invalid={hasError('consigneeTelephone', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
							/>
							<span className='form-item__error'>
								{error && error['consigneeTelephone']
									? t(error['consigneeTelephone'], { ns: 'errors' })
									: ''}
							</span>
						</div>
					</div> */}

					<div
						className={`form-group ${hasError('consigneeEmail', error) ? "red-border" : ""
							}`}
					>
						<CommonInput
							id='cconsigneeMail'
							name='consigneeMail'
							type='text'
							label={t('CAPTURE_AWB.EMAIL_HEAD')}
							maxLength='70'
							value={consigneeDetails.consigneeMail ? consigneeDetails.consigneeMail.toUpperCase() : ''}
							onChange={(e) => {
								setConsigneeDetails({
									...consigneeDetails,
									consigneeMail: e.target.value,
								})
							}}
							onBlur={(e) => {
								validateEmailIfPresent(
									e.target.value,
									setError,
									'consigneeEmail'
								)
							}}
							aria-invalid={hasError('consigneeEmail', error)}
							onFocus={(e) => {
								removeError(e, setError)
							}}
							error={error && error['consigneeEmail']
								? t(error['consigneeEmail'], { ns: 'errors' })
								: ''}
						/>
					</div>

					{/* <div className='form-row mt-lg-4 mb-3'>
						<div
							className='col-12 form-item form-item--text'
							data-module='molecules/form-item/FormItem'
						>
							<label className='form-item__label' htmlFor='cconsigneeMail'>
								{t('COMMON.EMAIL_HEAD')}
							</label>
							<input
								id='cconsigneeMail'
								name='consigneeMail'
								type='text'
								className='form-item__field'
								placeholder='Email address'
								maxLength='70'
								value={consigneeDetails.consigneeMail ? consigneeDetails.consigneeMail.toUpperCase():''}
								onChange={(e) => {
									setConsigneeDetails({
										...consigneeDetails,
										consigneeMail: e.target.value,
									})
								}}
								onBlur={(e) => {
									validateEmailIfPresent(
										e.target.value,
										setError,
										'consigneeEmail'
									)
								}}
								aria-invalid={hasError('consigneeEmail', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
							/>
							<span className='form-item__error'>
								{error && error['consigneeEmail']
									? t(error['consigneeEmail'], { ns: 'errors' })
									: ''}
							</span>
						</div>
					</div> */}
				</div>
			</div>
		 </div>	
		</div>	
		</div>
	)
}

export default ParticipantDetails
